import { bookingCancelPaymentPost } from "../../../app/api/cancelBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { showNotification } from "../../../Services/notificationService";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IRefundOfferRequest } from "../../../Orchestrator/Types/Types/BookingTypes";

interface IConfirmMultiBookingCancelParams {
  booking: IBookingResponse | null;
}

class ConfirmMultiBookingCancelAction extends BaseAction<
  IDefaultActionResult,
  IConfirmMultiBookingCancelParams
> {
  override async run(): Promise<IDefaultActionResult> {
    const result: IDefaultActionResult = {
      data: null,
      message: "",
      status: "fail",
    };

    try {
      const bookingResponse = this.params?.booking || null;
      const booking = bookingResponse?.booking;

      if (booking) {
        const fulfillmentIds = this.collectFulfillmentIds(booking);

        if (fulfillmentIds.length > 0) {
          const payload: IRefundOfferRequest = {
            fulfillmentIds,
            overruleCode: null,
            refundDate: new Date().toISOString(),
          };
          await bookingCancelPaymentPost(booking.id, payload);
          showNotification("info", getTranslatedMessage("cancelConfirmTitle"), getTranslatedMessage("cancelConfirmMessage"), 3);
        }

        result.status = "success";
      }
    } catch (error) { }

    return result;
  }

  private collectFulfillmentIds(booking: IBookingResponse["booking"]) {
    const ids = new Set<string>();

    (booking?.bookedOffers || []).forEach((offer: any) => {
      (offer?.admissions || []).forEach((admission: any) => {
        if (admission?.id && admission?.status !== "REFUNDED") {
          ids.add(admission.id);
        }
      });

      (offer?.ancillaries || []).forEach((ancillary: any) => {
        if (ancillary?.id && ancillary?.status !== "REFUNDED") {
          ids.add(ancillary.id);
        }
      });
    });

    return Array.from(ids);
  }
}

export const confirmMultiBookingCancelAction = new ConfirmMultiBookingCancelAction();

